import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  // iOS-friendly default attributes
  const iosProps = {
    autoCapitalize: type === 'email' ? 'none' : props.autoCapitalize,
    autoCorrect: type === 'email' || type === 'password' ? 'off' : props.autoCorrect,
    spellCheck: type === 'email' || type === 'password' ? 'false' : props.spellCheck,
  };

  return (
    <input
      type={type}
      className={cn(
        // Base styles
        "flex w-full rounded-md border border-input bg-white px-3 shadow-sm transition-colors",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        // Mobile-first: 52px min-height, 18px text for better iOS touch targets
        // Prevents iOS zoom on focus (requires 16px+ font)
        "min-h-[52px] py-3.5 text-[18px] leading-normal",
        // Desktop: smaller, more compact height
        "md:min-h-[36px] md:py-1 md:text-sm",
        className
      )}
      ref={ref}
      {...iosProps}
      {...props}
    />
  );
})
Input.displayName = "Input"

export { Input }
